<!-- eslint-disable max-len -->
<template>
  <div>
    <div class="native-button-tabs">
      <div
        v-for="tab in tabs"
        :key="tab.id"
        :class="{'active': tab.id === tabActive}"
        class="tab-list"
        @click="tabActive = tab.id"
      >
        {{ tab.name }}
      </div>
    </div>

    <!-- Non Workflow Button -->
    <div
      v-if="tabActive === 'non-workflow'"
      class="native-buttons"
    >
      <div class="d-flex align-items-center">
        <div
          v-if="menu === 'create'"
          :class="{ 'wrap-button-active': buttonActive === 'create'}"
          class="wrap-button"
        >
          <button class="button-blue">
            <span>
              {{ dataButtons.create && dataButtons.create.label ? dataButtons.create.label : 'Create' }}
            </span>
          </button>
          <!-- Edit -->
          <div
            class="edit"
            @click="$emit('select-btn', 'create', 'Create')"
          >
            <div class="button">
              <div>
                <i class="fa fa-pencil-square-o" />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="menu === 'detail'"
          :class="{ 'wrap-button-active': buttonActive === 'update'}"
          class="wrap-button"
        >
          <button class="button-blue">
            <span>
              {{ dataButtons.update && dataButtons.update.label ? dataButtons.update.label : 'Update' }}
            </span>
          </button>
          <!-- Edit -->
          <div
            class="edit"
            @click="$emit('select-btn', 'update', 'Update')"
          >
            <div class="button">
              <div>
                <i class="fa fa-pencil-square-o" />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="isPageScreen"
          :class="{ 'wrap-button-active': buttonActive === 'delete'}"
          class="wrap-button"
        >
          <button class="button-red">
            <span>
              {{ dataButtons.delete && dataButtons.delete.label ? dataButtons.delete.label : 'Delete' }}
            </span>
          </button>
          <!-- Edit -->
          <div
            class="edit"
            @click="$emit('select-btn', 'delete', 'Delete')"
          >
            <div class="button">
              <div>
                <i class="fa fa-pencil-square-o" />
              </div>
            </div>
          </div>
        </div>

        <div
          v-else
          class="wrap-button"
        >
          <button class="button-gray">
            <span>
              Close
            </span>
          </button>
        </div>
      </div>

      <div
        v-if="!isPageScreen && menu === 'detail'"
        :class="{ 'wrap-button-active': buttonActive === 'delete'}"
        class="wrap-button"
      >
        <button class="button-red">
          <span>
            {{ dataButtons.delete && dataButtons.delete.label ? dataButtons.delete.label : 'Delete' }}
          </span>
        </button>
        <!-- Edit -->
        <div
          class="edit"
          @click="$emit('select-btn', 'delete', 'Delete')"
        >
          <div class="button">
            <div>
              <i class="fa fa-pencil-square-o" />
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Requester Button -->
    <div
      v-if="tabActive === 'requester'"
      class="native-buttons"
    >
      <div class="d-flex align-items-center">
        <div
          v-if="menu === 'create'"
          :class="{ 'wrap-button-active': buttonActive === 'draft'}"
          class="wrap-button">
          <button class="button-blue">
            <span>
              {{ dataButtons.draft && dataButtons.draft.label ? dataButtons.draft.label : 'Save to Draft' }}
            </span>
          </button>
          <!-- Edit -->
          <div
            class="edit"
            @click="$emit('select-btn', 'draft', 'Save to Draft')"
          >
            <div class="button">
              <div>
                <i class="fa fa-pencil-square-o" />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="menu === 'create'"
          class="wrap-button">
          <button class="button-gray">
            <span>
              Close
            </span>
          </button>
        </div>

        <div
          v-if="menu === 'detail' && !isMultiple"
          :class="{ 'wrap-button-active': buttonActive === 'update'}"
          class="wrap-button">
          <button class="button-gray">
            <span>
              {{ dataButtons.update && dataButtons.update.label ? dataButtons.update.label : 'Update to Draft' }}
            </span>
          </button>
          <!-- Edit -->
          <div
            class="edit"
            @click="$emit('select-btn', 'update', 'Update to Draft')"
          >
            <div class="button">
              <div>
                <i class="fa fa-pencil-square-o" />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="menu === 'detail'"
          :class="{ 'wrap-button-active': buttonActive === 'submit'}"
          class="wrap-button">
          <button class="button-blue">
            <span>
              {{ dataButtons.submit && dataButtons.submit.label ? dataButtons.submit.label : 'Submit' }}
            </span>
          </button>
          <!-- Edit -->
          <div
            class="edit"
            @click="$emit('select-btn', 'submit', 'Submit')"
          >
            <div class="button">
              <div>
                <i class="fa fa-pencil-square-o" />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="menu === 'detail'"
          :class="{ 'wrap-button-active': buttonActive === 'close'}"
          class="wrap-button">
          <button class="button-green">
            <span>
              {{ dataButtons.close && dataButtons.close.label ? dataButtons.close.label : 'Close' }}
            </span>
          </button>
          <!-- Edit -->
          <div
            class="edit"
            @click="$emit('select-btn', 'close', 'Close')"
          >
            <div class="button">
              <div>
                <i class="fa fa-pencil-square-o" />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="menu === 'detail'"
          :class="{ 'wrap-button-active': buttonActive === 'cancel'}"
          class="wrap-button">
          <button class="button-brown">
            <span>
              {{ dataButtons.cancel && dataButtons.cancel.label ? dataButtons.cancel.label : 'Cancel' }}
            </span>
          </button>
          <!-- Edit -->
          <div
            class="edit"
            @click="$emit('select-btn', 'cancel', 'Cancel')"
          >
            <div class="button">
              <div>
                <i class="fa fa-pencil-square-o" />
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="d-flex">
        <div
          v-if="menu === 'detail'"
          :class="{ 'wrap-button-active': buttonActive === 'delete'}"
          class="wrap-button"
        >
          <button class="button-red">
            <span>
              {{ dataButtons.delete && dataButtons.delete.label ? dataButtons.delete.label : 'Delete' }}
            </span>
          </button>
          <!-- Edit -->
          <div
            class="edit"
            @click="$emit('select-btn', 'delete', 'Delete')"
          >
            <div class="button">
              <div>
                <i class="fa fa-pencil-square-o" />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="!isPageScreen && menu === 'detail'"
          class="wrap-button"
        >
          <button class="button-gray">
            <span>
              Close
            </span>
          </button>
        </div>
      </div>

    </div>

    <!-- Approver Button -->
    <div
      v-if="tabActive === 'approver'"
      class="native-buttons"
    >
      <div class="d-flex align-items-center">
        <div
          :class="{ 'wrap-button-active': buttonActive === 'approve'}"
          class="wrap-button"
        >
          <button class="button-blue">
            <span>
              {{ dataButtons.approve && dataButtons.approve.label ? dataButtons.approve.label : 'Approve' }}
            </span>
          </button>
          <!-- Edit -->
          <div
            class="edit"
            @click="$emit('select-btn', 'approve', 'Approve')"
          >
            <div class="button">
              <div>
                <i class="fa fa-pencil-square-o" />
              </div>
            </div>
          </div>
        </div>

        <div
          :class="{ 'wrap-button-active': buttonActive === 'approveUpdate'}"
          class="wrap-button"
        >
          <button class="button-blue">
            <span>
              {{ dataButtons.approveUpdate && dataButtons.approveUpdate.label ? dataButtons.approveUpdate.label : 'Approve & Update' }}
            </span>
          </button>
          <!-- Edit -->
          <div
            class="edit"
            @click="$emit('select-btn', 'approveUpdate', 'Approve & Update')"
          >
            <div class="button">
              <div>
                <i class="fa fa-pencil-square-o" />
              </div>
            </div>
          </div>
        </div>

        <div
          :class="{ 'wrap-button-active': buttonActive === 'reject'}"
          class="wrap-button"
        >
          <button class="button-purple">
            <span>
              {{ dataButtons.reject && dataButtons.reject.label ? dataButtons.reject.label : 'Reject' }}
            </span>
          </button>
          <!-- Edit -->
          <div
            class="edit"
            @click="$emit('select-btn', 'reject', 'Reject')"
          >
            <div class="button">
              <div>
                <i class="fa fa-pencil-square-o" />
              </div>
            </div>
          </div>
        </div>

        <div
          v-if="isWorkflow && isDynamicWorkflow && isApproverSelectionByFunction"
          :class="{ 'wrap-button-active': buttonActive === 'revision'}"
          class="wrap-button"
        >
          <button class="button-gray">
            <span>
              {{ dataButtons.revision && dataButtons.revision.label ? dataButtons.revision.label : 'Need Revision' }}
            </span>
          </button>
          <!-- Edit -->
          <div
            class="edit"
            @click="$emit('select-btn', 'revision', 'Need Revision')"
          >
            <div class="button">
              <div>
                <i class="fa fa-pencil-square-o" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dataButtons: {
      type: Object,
      default: () => {},
    },
    isWorkflow: {
      type: Boolean,
      default: false,
    },
    isMultiple: {
      type: Boolean,
      default: false,
    },
    isDynamicWorkflow: {
      type: Boolean,
      default: false,
    },
    isApproverSelectionByFunction: {
      type: Boolean,
      default: false,
    },
    buttonActive: {
      type: String,
      default: '',
    },
    isPageScreen: {
      type: Boolean,
      default: false,
    },
    menu: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      tabActive: 'non-workflow',
      tabs: [],
    };
  },

  created() {
    if (!this.isWorkflow) {
      this.tabs.push({
        id: 'non-workflow',
        name: 'Non Workflow',
      });
    } else if (this.menu === 'create') {
      this.tabs.push({
        id: 'non-workflow',
        name: 'Non Workflow',
      },
      {
        id: 'requester',
        name: 'With Workflow',
      });
    } else {
      this.tabs.push({
        id: 'non-workflow',
        name: 'Non Workflow',
      },
      {
        id: 'requester',
        name: 'Workflow (Requester)',
      },
      {
        id: 'approver',
        name: 'Workflow (Approver)',
      });
    }
  },
};
</script>



// WEBPACK FOOTER //
// src/views/experience-manager-v2/partials/NativeButtons.vue